import {Typography} from '@mui/material';
import {PropsWithChildren} from 'react';

import {useIsDownSm} from 'utils/hooks/useMediaQuery';

export const Block = ({
  className,
  children,
  label,
  helperText,
  ...rest
}: PropsWithChildren<{
  className?: string;
  label?: string;
  helperText?: string;
}>) => {
  const isDownSm = useIsDownSm();

  return (
    <div className={className} {...rest}>
      {label && (
        <Typography variant={isDownSm ? 'subtitle2' : 'subtitle1'} marginBottom={4}>
          {label}
        </Typography>
      )}
      {children}
      {helperText && (
        <Typography variant='body3' color='text.secondary' paragraph marginTop={4} marginBottom={0}>
          {helperText}
        </Typography>
      )}
    </div>
  );
};
